<script lang="ts">
  import { getContext } from 'svelte';
  import { push } from 'svelte-spa-router';
  import { loginUser } from '../../components/auth/LoginUser';
  import Loading from '../../etc/loader.svelte';
  import bundleOptionModal from '../../etc/modal/bundleoption/BundleOptionChangeModal.svelte';
  import RepositoryFactory, { BUNDLE_OPTION, CONTRACT } from '../../repositories/RepositoryFactory';
  import type { GetBundleOptionDisplayListResult } from '../../repositories/bundleoption';
  import type { GetContractResult } from '../../repositories/contract';

  const { open }: any = getContext('simple-modal');
  let contract: GetContractResult, bundleOptionList: GetBundleOptionDisplayListResult[];

  // Umobiledまたはエネコムで音声SIMで契約可能オプション群
  const umobiledVoiceSimRegister = [
    'UM_IFILTER',
    'EC_IFILTER',
    'UM_DENWA60',
    'EC_DENWA60',
    'UM_WARIKOMI',
    'EC_WARIKOMI',
    'UM_RUSUDEN',
    'EC_RUSUDEN'
  ];

  const UMOBILE_MAX_S_SERVICE_CODES = [
    'UM_VOICE_25G_MAX',
    'UM_DATA_1G_S',
    'UM_DATA_3G_S',
    'UM_DATA_7G_S',
    'UM_DATA_25G_MAX',
    'UM_DATA_30G_S'
  ];
  // Umobiledまたはエネコムで、データSIMまたはSMS付きSIMで契約可能オプション群
  const umobiledDataSimRegister = ['UM_IFILTER', 'EC_IFILTER'];

  let promise = getApi();

  // 契約情報取得
  async function getApi() {
    const contractRepository = RepositoryFactory[CONTRACT];
    const bundleOptionRepository = RepositoryFactory[BUNDLE_OPTION];

    await Promise.all([contractRepository.getContract(), bundleOptionRepository.getBundleOptionDisplayList()])
      .then((res) => {
        contract = res[0];
        bundleOptionList = res[1];
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          push('/login');
        } else {
          alert('エラーが発生しました。');
        }
        return false;
      });

    return { contract, bundleOptionList };
  }

  const showBundleOptionModal = (id: number) => {
    open(bundleOptionModal, {
      mstServiceId: id,
      serviceClass: contract.serviceClass
    });
  };

  const disabledApply = (serviceCode: string, bundleOptionId: number): boolean => {
    if (contract.contractStatusCode === 'TERMINATED') {
      return true;
    }
    // すでに申込済みの場合は可能
    if (bundleOptionId) {
      return false;
    }
    // Umobiled,エネコムの新規申込可否判定
    if (contract.serviceClass === 'VOICE_PLAN') {
      // 音声SIM＝留守電、割込電話、iフィルター、でんわパック、SIM安心サポートのみ新規申込可能
      return !umobiledVoiceSimRegister.includes(serviceCode);
    } else {
      // データSIM、SMS付きSIM＝iフィルター、SIM安心サポートのみ新規申込可能
      return !umobiledDataSimRegister.includes(serviceCode);
    }
  };

  const shouldDisplay = (contract: GetContractResult, bundleOption: GetBundleOptionDisplayListResult): boolean => {
    // でんわパック60 で UmobileMAX/Sのサービスコードの場合は表示しない
    if (isUmDenwa60AndUmomobileMaxS(contract, bundleOption)) {
      return false;
    }

    return true;
  };

  const isUmDenwa60AndUmomobileMaxS = (
    contract: GetContractResult,
    bundleOption: GetBundleOptionDisplayListResult
  ): boolean => {
    return UMOBILE_MAX_S_SERVICE_CODES.includes(contract.serviceCode) && bundleOption.serviceCode === 'UM_DENWA60';
  };
</script>

{#await promise}
  <Loading />
{:then { contract, bundleOptionList }}
  {#each bundleOptionList as bundleOption}
    {#if shouldDisplay(contract, bundleOption)}
      <div class="inline-grid grid-cols-3 justify-items-center items-center p-4">
        <div class="grid-1 col-span-2 justify-self-start">
          <span class="inline-block font-semibold">
            {bundleOption.serviceName}
          </span>
        </div>
        <div class="grid-1">
          <button
            on:click={() => showBundleOptionModal(bundleOption.mstServiceId)}
            class="button-primary"
            disabled={disabledApply(bundleOption.serviceCode, bundleOption.bundleOptionId)}
          >
            詳細
          </button>
        </div>
      </div>
    {/if}
  {/each}
{:catch error}
  <!-- API取得失敗 -->
{/await}

<style lang="postcss">
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default bg-gray-400;
  }
</style>
